// extracted by mini-css-extract-plugin
module.exports = {"container":"cart-upsell_container__Xx1CH","title":"cart-upsell_title__mS6_w","slide":"cart-upsell_slide__gPTv4"};